<template>
  <div>
    <PendingAudit />
    <CompletedAudit />
  </div>
</template>

<script>
import PendingAudit from './control-audit-assigned/PendingAudit.vue'
import CompletedAudit from './control-audit-assigned/CompletedAudit.vue'

export default {
  components: { PendingAudit, CompletedAudit },
}
</script>
